
import enCommon from './en/common';
import swCommon from './sw/common';

const messages = {
  en: {
    common: enCommon
  },
  sw: {
    common: swCommon
  }
};

export default messages;
